module.exports = __webpack_public_path__ + "img/266.c7f2f135.jpg";